import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { useRouter } from "next/router";
import Head from "next/head";

import DashboardSideNavigation from "components/DashboardSideNavigation";
import BackButton from "components/BackButton";
import { selectPlatformSourceFromApp } from "store/app/selectors";

const AdminBrokerPageProto = ({ children, className, headTitle, menu, topChildren, onClick, isBackUrl, isApp }) => {
    const router = useRouter();

    const [isMobileScreen, setMobileScreen] = useState(false);

    useEffect(() => {
        if (window.outerWidth < 992) {
            setMobileScreen(true);
        }
    }, []);

    return (
        <>
            {typeof headTitle === "string" ? (
                <Head>
                    <title>{headTitle}</title>
                </Head>
            ) : null}
            <div className={`broad-container two-column-page ${className}`}>
                {typeof topChildren !== "undefined" ? (typeof topChildren === "function" ? topChildren() : topChildren) : null}
                {isApp && isBackUrl && (
                    <BackButton
                        className="account-back-btn"
                        onClick={() => {
                            onClick ? onClick() : router.push(isBackUrl);
                        }}
                    />
                )}
                {!isApp && isMobileScreen && <DashboardSideNavigation mobile menu={menu} />}
                <div className="two-column-container table-container">
                    <div className="left-data">
                        <DashboardSideNavigation menu={menu} />
                    </div>
                    <div className="right-data">{children}</div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    isApp: selectPlatformSourceFromApp,
});

export default connect(mapStateToProps)(AdminBrokerPageProto);
